import { render } from "./ServiceModal.vue?vue&type=template&id=a82519dc"
import script from "./ServiceModal.vue?vue&type=script&lang=js"
export * from "./ServiceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__